var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrinter = function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".printer_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.5h11M16.5 7.5h-9v-7h7l2 2zM6.25 18.5H3.383a1 1 0 0 1-.992-.876L1.5 10.5h21l-.891 7.124a1 1 0 0 1-.992.876H17.25",
    className: "printer_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.5h3.323a1 1 0 0 1 .928.629L22.5 10.5h-21l1.749-4.371a1 1 0 0 1 .928-.629H7.5M7 15.5h9.5l2 8H5zM19.5 12.75a.25.25 0 1 1-.25.25.25.25 0 0 1 .25-.25M19.5 15.25a.25.25 0 1 1-.25.25.25.25 0 0 1 .25-.25M11.5 17.5H14M8.5 19.5h6M7.5 21.5H15",
    className: "printer_svg__a"
  })));
};
export default SvgPrinter;